import QRCode from "react-qr-code";
import {createRoot} from "react-dom/client";

function obtenerParametrosGET() {
    // Obtener la cadena de consulta de la URL
    const queryString = window.location.search;

    // Si no hay cadena de consulta, regresar un objeto vacío
    if (!queryString) {
        return {};
    }

    // Crear un objeto para almacenar los parámetros
    const parametros = {};

    // Eliminar el signo de interrogación inicial
    const cadenaParametros = queryString.substring(1);

    // Dividir la cadena en pares clave-valor
    const pares = cadenaParametros.split('&');

    // Iterar sobre los pares y agregar los parámetros al objeto
    for (const par of pares) {
        const [clave, valor] = par.split('=');
        parametros[clave] = decodeURIComponent(valor);
    }

    // Regresar el objeto de parámetros
    return parametros;
}

export const getTicket = () =>{
    console.log(obtenerParametrosGET())
    fetch("https://savethechildrenmx.org/api/event/1/payment/"+obtenerParametrosGET().compra,{
        method: "GET",
    }).then(response => {
        return response.json();
    }).then(json => {
        var obj = {
            id: json.id
        }
        document.querySelector(".mesa").textContent = json.event_table.name
        document.querySelector(".asientos").textContent = json.asientos - json.boletos_usados
        document.querySelector(".comprador").textContent = json.comprador

        const qrContainer = document.querySelector(".qr");
        const root = createRoot(qrContainer);

        root.render(<QRCode value={`ID ${json.id}`} />);

    })
}